import { Component, OnInit } from "@angular/core";
import * as moment from "moment";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { ReportService } from "../report.service";
import { UserService } from "../../../shared";

@Component({
	selector: "app-timestamp-time-in-event",
	templateUrl: "./timestamp-time-in-event.component.html",
	styleUrls: ["./timestamp-time-in-event.component.css"],
})
export class TimestampTimeInEventComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private reportService: ReportService,
		private dialogService: DialogService,
		private userService: UserService
	) {}

	report = {
		SchoolID: 0,
		HomeroomID: 0,
		GradeLevelID: 0,
		AcademyID: 0,
		GroupID: 0,
		TimeScanTypeID: 0,
		RunDate: new Date(),
		LateMinutes: 0,
		SortByID: "Status",
		SortDirectionID: "ASC",
		ImageLogo: "",
		AlertMode: 2,
		ShowAlertMessage: 1,
	};

	schoolList: any = [];
	homeroomList: any = [];
	gradeList: any = [];
	academyList: any = [];
	groupList: any = [];
	timeScanTypeDescList: any = [];
	ImageLogoList: any = [];

	AlertModeList: any = [
		{
			ID: 2,
			Desc: "Show Blocked Scans (Assume student never left school)",
		},
		{
			ID: 1,
			Desc: "Hide Blocked Scans (Assume student never left school)",
		},
		{
			ID: 0,
			Desc: "Ignore Reminders/Alerts (Assume student left school anyways)",
		},
	];
	ShowAlertMessageList: any = [
		{
			ID: 1,
			Desc: "Show Blocked Scan Message",
		},
		{
			ID: 0,
			Desc: "Don't Show Blocked Scan Message",
		},
	];

	SortByList: any = [
		{
			ID: "FirstName",
			Desc: "First Name",
		},
		{
			ID: "LastName",
			Desc: "Last Name",
		},
		{
			ID: "SchoolName",
			Desc: "School Name",
		},
		{
			ID: "SchoolNumber",
			Desc: "School Number",
		},
		{
			ID: "Status",
			Desc: "Status",
		},
		{
			ID: "LeftTime",
			Desc: "Left Time (When the student scanned into the event)",
		},
		{
			ID: "ReturnTime",
			Desc: "Return Time (When the student returned from the event)",
		},
		{
			ID: "TimeOut",
			Desc: "Time Out of School",
		},
	];

	SortDirectionList: any = [
		{
			ID: "ASC",
			Desc: "Ascending",
		},
		{
			ID: "DESC",
			Desc: "Descending",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 464;
	subscription: any;

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ngOnInit() {
		// this.loadSchoolist();
		this.user = this.userService.getCurrentUser();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(464);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.HomeroomList();
		this.AcademyList();
		this.GradeList();
		this.GroupList();
		this.TimeScanTypeList();
		this.loadLogolist();
	}

	private HomeroomList() {
		this.report.HomeroomID = 0;
		var result = this.reportService.HomeroomGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.homeroomList = response;

				if (this.homeroomList.length > 1) {
					this.homeroomList.unshift({
						HomeroomID: 0,
						HomeroomDesc: "All Homerooms",
					});
				} else {
					this.report.HomeroomID = this.homeroomList[0].HomeroomID;
				}
			},
			(error) => {}
		);
	}

	private AcademyList() {
		this.report.AcademyID = 0;
		var result = this.reportService.AcademyGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.academyList = response;

				if (this.academyList.length >= 0) {
					this.academyList.unshift({
						AcademyID: 0,
						AcademyDesc: "All Academies",
					});
				} else {
					this.report.AcademyID = this.academyList[0].AcademyID;
				}
			},
			(error) => {}
		);
	}

	private TimeScanTypeList() {
		this.report.TimeScanTypeID = 0;
		var result = this.reportService.TimeScanTypeGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.timeScanTypeDescList = response;

				// Remove All Scan Types
				if (this.timeScanTypeDescList.length > 0) {
					if (this.timeScanTypeDescList[0].TimeScanTypeID <= 0) {
						this.timeScanTypeDescList.splice(0, 1);
					}
				}

				this.report.TimeScanTypeID = this.timeScanTypeDescList[0].TimeScanTypeID;
			},
			(error) => {}
		);
	}

	private GradeList() {
		this.report.GradeLevelID = 0;
		var result = this.reportService.GradesGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.gradeList = response;

				if (this.gradeList.length > 1) {
					this.gradeList.unshift({
						GradeLevelID: 0,
						GradeLevelDesc: "All Grades",
					});
				} else {
					this.report.GradeLevelID = this.gradeList[0].GradeLevelID;
				}
			},
			(error) => {}
		);
	}

	private GroupList() {
		this.report.GroupID = 0;

		var result = this.reportService.GroupGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.groupList = response;

				if (this.groupList.length >= 0) {
					this.groupList.unshift({
						GroupID: 0,
						GroupName: "All Groups",
					});
					this.report.GroupID = this.groupList[0].GroupID;
				} else if (this.groupList.length == 1) {
					this.report.GroupID = this.groupList[0].GroupID;
				}
				// else  {
				//     this.groupList.push({
				//         GroupID: 0,
				//         GroupName: "No Record found"
				//     })
				// }
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		// if (!this.report.HomeroomID) {
		//     this.errorMessage = "Select the Homeroom";
		//     return
		// }

		this.isProcessing = true;

		var strParam = this.GetStrParam();

		var reportID = 464;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);
		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		var RunDateDesc = moment(this.report.RunDate).format("MM/DD/YYYY");
		var LateMinuteDesc = 0;

		if (this.report.LateMinutes > 0) {
			LateMinuteDesc = this.report.LateMinutes;
		}

		strParam += this.report.GradeLevelID + "|GradeLevelID";
		strParam += "," + this.report.AcademyID + "|AcademyID";
		strParam += "," + this.report.HomeroomID + "|HomeroomID";
		strParam += "," + this.report.GroupID + "|GroupID";
		strParam += "," + this.report.TimeScanTypeID + "|TimeScanTypeID";
		strParam += "," + RunDateDesc + "|RunDate";
		strParam += "," + LateMinuteDesc + "|LateMinutes";
		strParam += "," + this.report.SortByID + "|SortBy";
		strParam += "," + this.report.SortDirectionID + "|SortDirection";
		strParam += "," + this.user.userID + "|UserID";
		strParam += "," + this.report.SchoolID + "|SchoolID";
		// strParam += "," + this.report.AlertMode + "|AlertMode";
		// strParam += "," + this.report.ShowAlertMessage + "|ShowAlertMessage";

		// strParam += "," + vm.searchOptions.sortBy + "|ORDERBY"
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
